import React, { useState } from "react";
import { Loader, Segment, Menu } from "semantic-ui-react";

import EvaluatedCriteria from "./EvaluatedCriteria";
import EvaluationSummary from "./EvaluationSummary";
import { useFetchEvaluationSessionByIdQuery } from "./evaluationSessionApiSlice";

const EvaluationTabbedResult = ({ evaluationsession_pk }) => {
  const { data, isLoading } = useFetchEvaluationSessionByIdQuery(evaluationsession_pk, {
    pollingInterval: 5000,
  });

  // active detail to toggle between criteria list and summary on the right pane
  const [selectedActiveTab, setSelectedActiveTab] = useState("tab_summary");

  if (isLoading) {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Segment attached="bottom" style={{ flex: 1, overflowY: 'auto' }}>
          <Loader active />
        </Segment>
      </div>
    );
  } else {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', borderBottom: '1px solid rgba(34,36,38,.15)', backgroundColor: '#f9fafb' }}>
          <div 
              onClick={() => setSelectedActiveTab("tab_summary")}
              style={{ 
                  padding: '12px 20px', 
                  cursor: 'pointer', 
                  fontWeight: selectedActiveTab === "tab_summary" ? '600' : 'normal',
                  color: selectedActiveTab === "tab_summary" ? '#007AFF' : 'rgba(0,0,0,0.6)',
                  borderBottom: selectedActiveTab === "tab_summary" ? '2px solid #007AFF' : 'none',
                  marginBottom: '-1px',
                  fontSize: '14px'
              }}
          >
              평가 요약
          </div>
          <div 
              onClick={() => setSelectedActiveTab("tab_criteria")}
              style={{ 
                  padding: '12px 20px', 
                  cursor: 'pointer', 
                  fontWeight: selectedActiveTab === "tab_criteria" ? '600' : 'normal',
                  color: selectedActiveTab === "tab_criteria" ? '#007AFF' : 'rgba(0,0,0,0.6)',
                  borderBottom: selectedActiveTab === "tab_criteria" ? '2px solid #007AFF' : 'none',
                  marginBottom: '-1px',
                  fontSize: '14px'
              }}
          >
              평가 항목
          </div>

        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', overflowX: 'hidden' }}>
          {selectedActiveTab === "tab_criteria"
            ? data && (
                <EvaluatedCriteria evaluatedcriterion_set={data.evaluatedcriterion_set} />
              )
            : data && (
                <EvaluationSummary evaluationsession={data} />
              )}
        </div>
      </div>
    );
  }
};

export default EvaluationTabbedResult;
